import api from ".";
import { siRatingEndpoints } from "./endpoints/siRating.endpoints";

function saveBlob(blob, fallbackName, disposition) {
  const match = /filename="?([^"]+)"?/.exec(disposition || "");
  const url = window.URL.createObjectURL(blob);
  const a = document.createElement("a");
  a.href = url;
  a.download = match?.[1] || fallbackName;
  document.body.appendChild(a);
  a.click();
  a.remove();
  window.URL.revokeObjectURL(url);
}

async function download(url, fallbackName) {
  const res = await api.get(url, { responseType: "blob" });
  saveBlob(res.data, fallbackName, res.headers?.["content-disposition"]);
}

export const siRatingApis = {
  listSectors: async () => {
    const res = await api.get(siRatingEndpoints.sectors);
    return res.data?.sectors || [];
  },

  run: async (payload) => {
    const res = await api.post(siRatingEndpoints.run, payload);
    return res.data?.data;
  },

  listMine: async () => {
    const res = await api.get(siRatingEndpoints.mine);
    return res.data?.ratings || [];
  },

  get: async (id) => {
    const res = await api.get(siRatingEndpoints.get(id));
    return res.data?.data;
  },

  uploadPdfReports: async (id, files, { role = "gap", year } = {}) => {
    const form = new FormData();
    Array.from(files).forEach((f) => form.append("files", f));
    form.append("role", role);
    if (year) form.append("year", year);
    const res = await api.post(siRatingEndpoints.pdfReports(id), form, {
      headers: { "Content-Type": "multipart/form-data" },
    });
    return res.data?.data;
  },

  /** body: { candidates: [{id, status, role}], overrides: {datapoint: {value, note} | {value:null} | null} } */
  updateValues: async (id, body) => {
    const res = await api.patch(siRatingEndpoints.values(id), body);
    return res.data?.data;
  },

  refreshSdm: async (id) => {
    const res = await api.post(siRatingEndpoints.refreshSdm(id));
    return res.data?.data;
  },

  finalize: async (id) => {
    const res = await api.post(siRatingEndpoints.finalize(id));
    return res.data?.data;
  },

  downloadExcel: (id) => download(siRatingEndpoints.exportXlsx(id), "SI_Rating.xlsx"),
  downloadReportPdf: (id) => download(siRatingEndpoints.reportPdf(id), "SI_Rating_Report.pdf"),
};
